import { render, staticRenderFns } from "./FormSelectBrand.vue?vue&type=template&id=f3141bce&"
import script from "./FormSelectBrand.vue?vue&type=script&lang=js&"
export * from "./FormSelectBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports